import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bureau',
  templateUrl: './bureau.component.html',
  styleUrls: ['./bureau.component.css']
})
export class BureauComponent implements OnInit {

  constructor() { }
 
  ngOnInit(): void {
  }

}
